export default __webpack_public_path__ + "static/media/icon-infusion.50a05798.svg";